<div class="row">
    <div class="column small-12 medium-6">
        <div class="miniBook__container" id="departureType">
            <div class="miniBook miniBook__return"
                [ngClass]="{ miniBook__grey: isOneWayOnly(), miniBook__selected: !oneWay.value }"
                (click)="changeDepartureType('return')">
                {{content.fields.return}}
            </div>
            <div class="miniBook miniBook__oneWay"
                [ngClass]="{ miniBook__grey: isMiniCruise(), miniBook__selected: oneWay.value }"
                (click)="changeDepartureType('oneway')">
                {{content.fields.oneway}}
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="column small-12 medium-6">
        <div class="row">
            <div class="column small-12">
                <div class="field">
                    <span class="label">{{ 'OUTWARD_ROUTE' | resource }}</span>
                    <select [class.oneway]="oneWay.value" [class.return]="!oneWay.value"
                        [formControl]="outboundRouteCode" id="departureRoute">
                        <option *ngFor="let route of outboundRoute.routes" [value]="route.routeCode">
                            {{route.description}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="column small-12 medium-6">
        <div class="row">
            <div class="column small-12 end">
                <sbw-date-range-picker id="departureReturnDate" [departureDateControl]="outboundDepartureDate"
                    [returnDateControl]="returnDepartureDate" outboundLabel="{{ 'DEPARTURE_DATE' | resource }}"
                    returnLabel="{{ 'RETURN_DATE' | resource }}" [outboundIcon]="getOutboundDateIcon()"
                    [returnIcon]="getReturnDateIcon()" h2Label="{{content.fields.selectDate}}"
                    [outbound]="outboundRoute.date" [return]="returnRoute.date"
                    [infoLabel]="datePickerInfoLabel"
                    infoLegendClass="dateRangePickerInfo__legend"
                     >
                </sbw-date-range-picker>
            </div>
        </div>
    </div>
</div>
